export const setGateData = (value) => {
  return {
    type: "SET_GATE_DATA",
    payload: { data: value },
  };
};

export const setGateCount = (value) => {
  return {
    type: "SET_GATE_COUNT",
    payload: { data: value },
  };
};

export const setGatesData = (value) => {
  return {
    type: "SET_GATES_DATA",
    payload: { data: value },
  };
};

// Permanent Access Actions
export const setPermanentAccessData = (value) => {
  return {
    type: "SET_PERMANENT_ACCESS_DATA",
    payload: { data: value },
  };
};

export const setPermanentAccessCount = (value) => {
  return {
    type: "SET_PERMANENT_ACCESS_COUNT",
    payload: { data: value },
  };
};

export const setPermanentAccessLoading = (value) => {
  return {
    type: "SET_PERMANENT_ACCESS_LOADING",
    payload: { data: value },
  };
};

//socket-related action
export const setGateConnectionStatus = (status) => {
  return {
    type: "SET_GATE_CONNECTION_STATUS",
    payload: { data: status },
  };
};

//socket-related action
export const setMemberAccess = (memberData) => {
  return {
    type: "SET_MEMBER_ACCESS",
    payload: { data: memberData },
  };
};

export const setConnectionError = (error) => ({
  type: "SET_CONNECTION_ERROR",
  payload: { data: error }
});

export const setConnectedClients = (count) => ({
  type: "SET_CONNECTED_CLIENTS",
  payload: { data: count }
});